<template>
  <button @click="onClick"
    :class="{ active: count > 0 }"
  >{{ label }}</button>
</template>

<script>
export default {
  props: {
    count: {
      type: [Number, Boolean],
      required: false,
      default: false
    },

    name: {
      type: String,
      required: true,
      default: ''
    },

    type: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
    label () {
      if (Number.isInteger(this.count) && this.count > 0) {
        return `${this.name} • ${this.count}`
      }
      return this.name
    }
  },
  methods: {
    onClick () {
      this.$emit('click', this.type)
    }
  }
}
</script>

<style lang="scss" scoped>
  
  button {
    @include fontBold('040');
    background: $color-white;
    border-radius: 2px;
    border: $line-medium;
    cursor: pointer;
    display: block;
    padding: $space-030 $space-040;
    width: 100%;
    @include transition-fast;

    @include breakpoint(medium) {
      display: inline-block;
      width: auto;
    }

    &:disabled:hover {
      opacity: .7;
    }

    &:not(:disabled) {
      @include deprecated-f-color-dark;

      &:hover {
        background: $color-white;
        border-color: $color-black
      }

      &:active {
        color: $color-white;
        background: $color-black;
        border-color: $color-black;
      }

      &.active {
        @include f-color-white();
        
        background: $color-black;
        pointer-events: none;
      }
    }

    &:disabled {
      cursor: not-allowed;
    }

  }
</style>
